export const name = 'aboveTheFoldService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-above-the-fold'
